export default {
  getMyShopCouponList: '/gateway/coupon/shopCoupon/getCouponList'
}
